import { Component } from '@angular/core';

/**
 *  @description 
 *  - A dummy component used for redirecting child routes.
 *  - This component does not render any UI and serves as a placeholder
 *     to facilitate route redirection.
 *  - It is used in routing configurations where a parent route
 *     needs to redirect to a default child route.
 *  - For example, navigating to '/parent' can redirect to '/parent/child'
 *     by using this component as the parent route's component.
 */
@Component({
    template: '',
    standalone: false
})
export class ChildRouteRedirectComponent { }
